import { environment } from '@env';
import { useApiFetch } from './useApiFetch';

export const useApiServiceInference = () => {
  const fetchData = useApiFetch();

  const getAssemblies = async () => {
    const url = `${environment.BASE_URL}v1/dgs/inference/assembly`;
    return fetchData(url);
  };

  const getDryGasSealTagsSelection = async datasource_id => {
    const url = `${environment.BASE_URL}v1/dgs/inference/${datasource_id}/tags`;
    return fetchData(url);
  };

  
  const PAGE_SIZE = 100000;

  const getTagsPaginationInfo = async (from, to, modelName) => {
    const url = `${environment.BASE_URL}v1/dgs/inference/pagination-info?from=${from}&to=${to}&model_id=${modelName}&page_size=${PAGE_SIZE}`;
    return fetchData(url);
  };

  const getTagsCombination = async (from, to, modelName, page = 1) => {
    const url = `${environment.BASE_URL}v1/dgs/inference/?from=${from}&to=${to}&model_id=${modelName}&page=${page}&page_size=${PAGE_SIZE}`;
    return fetchData(url);
  };

  const getTags = async (from, to, modelName, tagAlias) => {
    const url = `${environment.BASE_URL}v1/dgs/inference/tags?from=${from}&to=${to}&model_id=${modelName}&tag_alias=${tagAlias}`;
    return fetchData(url);
  };

  const getActiveModels = async (tagAlias, datasource_id) => {
    let tag_alias_name;
    if (Array.isArray(tagAlias)) {
      tag_alias_name = [`[${tagAlias.map(t => `'${t}'`).join(', ')}]`];
    } else {
      tag_alias_name = [String(tagAlias)];
    }

    const url = `${environment.BASE_URL}v1/dgs/train/models?status=ACTIVE&limit=60&offset=0`;
    const requestBody = {
      datasource_id,
      tag_alias_name
    };
    return fetchData(url, 'POST', requestBody);
  };

  const forecast = async payload => {
    console.log('Forecast Request Body:', payload);
    return fetchData(
      `${environment.BASE_URL}v1/dgs/forecast/`,
      'POST',
      payload
    );
  };

  return {
    getAssemblies,
    getDryGasSealTagsSelection,
    getTagsPaginationInfo,
    getTagsCombination,
    getTags,
    getActiveModels,
    forecast
  };
};
